import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'
import { IdentityServiceApi } from '../../../api'

export const QUERY = gql`
  query RetrieveDeviceCheckKeyMetaData(
    $input: RetrieveDeviceCheckKeyMetaDataInput!
  ) {
    retrieveDeviceCheckKeyMetaData(input: $input) {
      keyId
      issuer
    }
  }
`

export async function retrieveDeviceCheckKeyMetaData(
  client: ApolloClient<unknown>,
): Promise<IdentityServiceApi['DeviceCheckKeyMetaData']> {
  const response = await client.query({
    query: QUERY,
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        buildType: 'release',
      },
    },
  })
  return response.data.retrieveDeviceCheckKeyMetaData
}
